/* eslint-disable max-lines */
import tokens from '@quintoandar/cozy-theme/tokens/js';

import * as v2 from './v2/constants';

import messages from './messages';

export const isSinkAndCeilingEnabled = () =>
  process.env.PROPERTY_ASSESSMENT_IS_SINK_AND_CEILING_ENABLED === 'true';

export const isIntercomEnabled = () =>
  process.env.PROPERTY_ASSESSMENT_INTERCOM_ENABLED === 'true';

export const SET_HELP_DIALOG_OPEN = 'PROPERTY_ASSESSMENT/SET_HELP_DIALOG_OPEN';
export const SET_HELP_DIALOG_CLOSE =
  'PROPERTY_ASSESSMENT/SET_HELP_DIALOG_CLOSE';
export const SET_ITEM_VALUE = 'PROPERTY_ASSESSMENT/SET_ITEM_VALUE';
export const LOAD_ASSESSMENT = 'PROPERTY_ASSESSMENT/LOAD_ASSESSMENT';
export const TRACK_CHECKLIST_GENERAL_CONDITIONS_CLOSE_BUTTON_CLICKED =
  'PROPERTY_ASSESSMENT/TRACK_CHECKLIST_GENERAL_CONDITIONS_CLOSE_BUTTON_CLICKED';
export const TRACK_CHECKLIST_GENERAL_CONDITIONS_FINISH_BUTTON_CLICKED =
  'PROPERTY_ASSESSMENT/TRACK_CHECKLIST_GENERAL_CONDITIONS_FINISH_BUTTON_CLICKED';
export const TRACK_CHECKLIST_GENERAL_CONDITIONS_FINISH_CONFIRMED =
  'PROPERTY_ASSESSMENT/TRACK_CHECKLIST_GENERAL_CONDITIONS_FINISH_CONFIRMED';
export const COMPLETE_ASSESSMENT = 'PROPERTY_ASSESSMENT/COMPLETE_ASSESSMENT';
export const TRACK_CHECKLIST_ASSESSMENT_PAGE_VIEWED =
  'PROPERTY_ASSESSMENT/TRACK_CHECKLIST_ASSESSMENT_PAGE_VIEWED';
export const TRACK_CHECKLIST_ASSESSMENT_CONFIRMATION_PAGE_VIEWED =
  'PROPERTY_ASSESSMENT/TRACK_CHECKLIST_ASSESSMENT_CONFIRMATION_PAGE_VIEWED';
export const TRACK_CHECKLIST_GENERAL_CONDITIONS_ERROR_CTA_VIEWED =
  'PROPERTY_ASSESSMENT/TRACK_CHECKLIST_GENERAL_CONDITIONS_ERROR_CTA_VIEWED';
export const TRACK_CHECKLIST_GENERAL_CONDITIONS_DOUBTS_BUTTON_CLICKED =
  'PROPERTY_ASESSMENT/TRACK_GENERAL_CONDITIONS_DOUBTS_BUTTON_CLICKED';
export const TRACK_CHECKLIST_USEFUL_INFORMATION_BUTTON_CLICKED =
  'PROPERTY_ASSESSMENT/TRACK_CHECKLIST_USEFUL_INFORMATION_BUTTON_CLICKED';
export const UPDATE_SECTION_VISIBILITY =
  'PROPERTY_ASSESSMENT/UPDATE_SECTION_VISIBILITY';
export const UPDATE_ASSESSMENT_V2_ENABLED =
  'PROPERTY_ASSESSMENT/UPDATE_ASSESSMENT_V2_ENABLED';

export const STATUS = Object.freeze({
  NOT_STARTED: 'NOT_STARTED',
  STARTED: 'STARTED',
  COMPLETED: 'COMPLETED',
});

export const GROUPS = Object.freeze({
  ELECTRICAL: 'ELECTRICAL',
  HYDRAULIC: 'HYDRAULIC',
  STRUCTURE: 'STRUCTURE',
  PROPERTY_ITEMS: 'PROPERTY_ITEMS',

  ...(v2.isEnabled() ? v2.GROUP : {}),
});

export const SECTIONS = Object.freeze({
  ELECTRICAL: 'ELECTRICAL',
  FUSEBOX: 'FUSEBOX',
  LIGHT: 'LIGHT',
  SWITCH_SOCKET: 'SWITCH_SOCKET',
  HYDRAULIC: 'HYDRAULIC',
  REGISTER: 'REGISTER',
  TOILET: 'TOILET',
  VALVE: 'VALVE',
  ...(isSinkAndCeilingEnabled() ? { SINK: 'SINK' } : {}),
  FAUCET: 'FAUCET',
  SIPHON_TAIL: 'SIPHON_TAIL',
  SHOWER: 'SHOWER',
  STRUCTURE: 'STRUCTURE',
  WALL: 'WALL',
  ...(isSinkAndCeilingEnabled() ? { CEILING: 'CEILING' } : {}),
  FLOOR: 'FLOOR',
  DOOR_LOCK: 'DOOR_LOCK',
  WINDOW: 'WINDOW',
  PROPERTY_ITEMS: 'PROPERTY_ITEMS',
  ...(isIntercomEnabled() ? { INTERCOM: 'INTERCOM' } : {}),
  BATHROOM_STALL: 'BATHROOM_STALL',
  BATHROOM_CABINET: 'BATHROOM_CABINET',
  BEDROOM_CLOSET: 'BEDROOM_CLOSET',
  KITCHEN_CABINET: 'KITCHEN_CABINET',

  ...(v2.isEnabled() ? v2.SECTION : {}),
});

export const SORTED_SECTIONS = [
  SECTIONS.ELECTRICAL,
  SECTIONS.FUSEBOX,
  SECTIONS.LIGHT,
  SECTIONS.SWITCH_SOCKET,
  SECTIONS.HYDRAULIC,
  SECTIONS.REGISTER,
  SECTIONS.TOILET,
  SECTIONS.VALVE,

  ...(isSinkAndCeilingEnabled() ? [SECTIONS.SINK] : []),

  SECTIONS.FAUCET,
  SECTIONS.SIPHON_TAIL,
  SECTIONS.SHOWER,
  SECTIONS.STRUCTURE,
  SECTIONS.WALL,

  ...(isSinkAndCeilingEnabled() ? [SECTIONS.CEILING] : []),

  SECTIONS.FLOOR,
  SECTIONS.DOOR_LOCK,
  SECTIONS.WINDOW,
  SECTIONS.PROPERTY_ITEMS,

  ...(isIntercomEnabled() ? [SECTIONS.INTERCOM] : []),

  SECTIONS.BATHROOM_STALL,
  SECTIONS.BATHROOM_CABINET,
  SECTIONS.BEDROOM_CLOSET,
  SECTIONS.KITCHEN_CABINET,

  ...(v2.isEnabled()
    ? [
      v2.SECTION.GAS,
      v2.SECTION.GAS_SUPPLY,
      v2.SECTION.GAS_REGISTER_1,
      v2.SECTION.GAS_REGISTER_2,
      v2.SECTION.WATER_HEATER_1,
      v2.SECTION.WATER_HEATER_2,
    ]
    : []),
];

export const INPUT_TYPES = Object.freeze({
  INPUT: 'INPUT',
  CHIP: 'CHIP',
  RADIO: 'RADIO',

  ...(v2.isEnabled() ? v2.INPUT : {}),
});

export const ASSESSMENT_V2_SECTIONS = [
  SECTIONS.SINK,
  SECTIONS.CEILING,
  SECTIONS.INTERCOM,
  SECTIONS.GAS,
  SECTIONS.GAS_SUPPLY,
  SECTIONS.GAS_REGISTER_1,
  SECTIONS.GAS_REGISTER_2,
  SECTIONS.WATER_HEATER_1,
  SECTIONS.WATER_HEATER_2,
];

export const IS_WORKING_TYPES = Object.freeze({
  YES: 'YES',
  NO: 'NO',
  NO_ANSWER: 'NO_ANSWER',
});

export const DEFECTIVE_IN_TYPES = Object.freeze({
  BEDROOM: 'BEDROOM',
  LIVING_ROOM: 'LIVING_ROOM',
  SERVICE_AREA: 'SERVICE_AREA',
  BATHROOM: 'BATHROOM',
  KITCHEN: 'KITCHEN',
  OTHER: 'OTHER',
});

export const CONSERVATION_TYPES = Object.freeze({
  NEEDS_REPAIR: 'NEEDS_REPAIR',
  MANY_SIGNS_OF_USE: 'MANY_SIGNS_OF_USE',
  FEW_SIGNS_OF_USE: 'FEW_SIGNS_OF_USE',
  NEW_ITEM: 'NEW_ITEM',
});

export const MAINTENANCE_CONDITION = Object.freeze({
  PERFECT_STATE: 'PERFECT_STATE',
  ALMOST_PERFECT_STATE: 'ALMOST_PERFECT_STATE',
  NEW_OR_WITHOUT_BASIC_ITENS: 'NEW_OR_WITHOUT_BASIC_ITENS',
  OLD: 'OLD',
  POORLY_MAINTAINED: 'POORLY_MAINTAINED',
});

export const GROUP_BY_SECTION = Object.freeze({
  [SECTIONS.FUSEBOX]: GROUPS.ELECTRICAL,
  [SECTIONS.LIGHT]: GROUPS.ELECTRICAL,
  [SECTIONS.SWITCH_SOCKET]: GROUPS.ELECTRICAL,
  [SECTIONS.REGISTER]: GROUPS.HYDRAULIC,
  [SECTIONS.TOILET]: GROUPS.HYDRAULIC,
  [SECTIONS.VALVE]: GROUPS.HYDRAULIC,
  ...(isSinkAndCeilingEnabled() ? { [SECTIONS.SINK]: GROUPS.HYDRAULIC } : {}),
  [SECTIONS.FAUCET]: GROUPS.HYDRAULIC,
  [SECTIONS.SIPHON_TAIL]: GROUPS.HYDRAULIC,
  [SECTIONS.SHOWER]: GROUPS.HYDRAULIC,
  [SECTIONS.WALL]: GROUPS.STRUCTURE,
  ...(isSinkAndCeilingEnabled()
    ? { [SECTIONS.CEILING]: GROUPS.STRUCTURE }
    : {}),
  [SECTIONS.FLOOR]: GROUPS.STRUCTURE,
  [SECTIONS.DOOR_LOCK]: GROUPS.STRUCTURE,
  [SECTIONS.WINDOW]: GROUPS.STRUCTURE,
  ...(isIntercomEnabled()
    ? { [SECTIONS.INTERCOM]: GROUPS.PROPERTY_ITEMS }
    : {}),
  [SECTIONS.BATHROOM_STALL]: GROUPS.PROPERTY_ITEMS,
  [SECTIONS.BATHROOM_CABINET]: GROUPS.PROPERTY_ITEMS,
  [SECTIONS.BEDROOM_CLOSET]: GROUPS.PROPERTY_ITEMS,
  [SECTIONS.KITCHEN_CABINET]: GROUPS.PROPERTY_ITEMS,

  ...(v2.isEnabled() ? v2.GROUP_BY_SECTION : {}),
});

export const SLUGS = Object.freeze({
  ELECTRICAL: 'instalacoes-eletricas',
  FUSEBOX: 'quadros-de-energia',
  LIGHT: 'luminarias',
  SWITCH_SOCKET: 'tomadas',
  HYDRAULIC: 'instalacoes-hidraulicas',
  REGISTER: 'registros',
  TOILET: 'vasos-sanitarios',
  VALVE: 'valvulas-de-descarga',
  ...(isSinkAndCeilingEnabled() ? { SINK: 'pias-ou-cubas' } : {}),
  FAUCET: 'torneiras',
  SIPHON_TAIL: 'sifoes-das-pias',
  SHOWER: 'chuveiros',
  STRUCTURE: 'estrutura-fisica',
  WALL: 'paredes',
  ...(isSinkAndCeilingEnabled() ? { CEILING: 'teto' } : {}),
  FLOOR: 'pisos',
  DOOR_LOCK: 'portas-e-fechaduras',
  WINDOW: 'janelas',
  PROPERTY_ITEMS: 'itens-do-imovel',
  ...(isIntercomEnabled() ? { INTERCOM: 'interfone' } : {}),
  BATHROOM_STALL: 'boxes-dos-banheiros',
  BATHROOM_CABINET: 'armarios-do-banheiro',
  BEDROOM_CLOSET: 'armarios-do-quarto',
  KITCHEN_CABINET: 'armarios-da-cozinha',

  ...(v2.isEnabled() ? v2.SLUG : {}),
});

export const SECTION_TO_PAGE_VIEWED_EVENT_MAP = Object.freeze({
  [SECTIONS.ELECTRICAL]: 'checklist_electrical_installation_page_viewed',
  [SECTIONS.FUSEBOX]: 'checklist_power_board_page_viewed',
  [SECTIONS.LIGHT]: 'checklist_lighting_page_viewed',
  [SECTIONS.SWITCH_SOCKET]: 'checklist_socket_page_viewed',
  [SECTIONS.HYDRAULIC]: 'checklist_hydraulic_installation_page_viewed',
  [SECTIONS.REGISTER]: 'checklist_water_valve_page_viewed',
  [SECTIONS.TOILET]: 'checklist_toilet_page_viewed',
  [SECTIONS.VALVE]: 'checklist_flush_page_viewed',
  ...(isSinkAndCeilingEnabled()
    ? { [SECTIONS.SINK]: 'checklist_sink_page_viewed' }
    : {}),
  [SECTIONS.FAUCET]: 'checklist_faucet_page_viewed',
  [SECTIONS.SIPHON_TAIL]: 'checklist_siphon_page_viewed',
  [SECTIONS.SHOWER]: 'checklist_shower_page_viewed',
  [SECTIONS.STRUCTURE]: 'checklist_physical_structure_page_viewed',
  [SECTIONS.WALL]: 'checklist_walls_page_viewed',
  ...(isSinkAndCeilingEnabled()
    ? { [SECTIONS.CEILING]: 'checklist_ceiling_page_viewed' }
    : {}),
  [SECTIONS.FLOOR]: 'checklist_floor_page_viewed',
  [SECTIONS.DOOR_LOCK]: 'checklist_doors_and_locks_page_viewed',
  [SECTIONS.WINDOW]: 'checklist_windows_page_viewed',
  [SECTIONS.PROPERTY_ITEMS]: 'checklist_property_items_page_viewed',
  ...(isIntercomEnabled()
    ? { [SECTIONS.INTERCOM]: 'checklist_intercom_page_viewed' }
    : {}),
  [SECTIONS.BATHROOM_STALL]: 'checklist_bathroom_box_page_viewed',
  [SECTIONS.BATHROOM_CABINET]: 'checklist_bathroom_cabinets_page_viewed',
  [SECTIONS.BEDROOM_CLOSET]: 'checklist_bedroom_cabinets_page_viewed',
  [SECTIONS.KITCHEN_CABINET]: 'checklist_kitchen_cabinets_page_viewed',

  ...(v2.isEnabled() ? v2.PAGE_VIEWED_EVENT_BY_SECTION : {}),
});

export const SECTION_TO_SLUG_MAP = Object.freeze({
  [SECTIONS.ELECTRICAL]: SLUGS.ELECTRICAL,
  [SECTIONS.FUSEBOX]: SLUGS.FUSEBOX,
  [SECTIONS.LIGHT]: SLUGS.LIGHT,
  [SECTIONS.SWITCH_SOCKET]: SLUGS.SWITCH_SOCKET,
  [SECTIONS.HYDRAULIC]: SLUGS.HYDRAULIC,
  [SECTIONS.REGISTER]: SLUGS.REGISTER,
  [SECTIONS.TOILET]: SLUGS.TOILET,
  [SECTIONS.VALVE]: SLUGS.VALVE,
  ...(isSinkAndCeilingEnabled() ? { [SECTIONS.SINK]: SLUGS.SINK } : {}),
  [SECTIONS.FAUCET]: SLUGS.FAUCET,
  [SECTIONS.SIPHON_TAIL]: SLUGS.SIPHON_TAIL,
  [SECTIONS.SHOWER]: SLUGS.SHOWER,
  [SECTIONS.STRUCTURE]: SLUGS.STRUCTURE,
  [SECTIONS.WALL]: SLUGS.WALL,
  ...(isSinkAndCeilingEnabled() ? { [SECTIONS.CEILING]: SLUGS.CEILING } : {}),
  [SECTIONS.FLOOR]: SLUGS.FLOOR,
  [SECTIONS.DOOR_LOCK]: SLUGS.DOOR_LOCK,
  [SECTIONS.WINDOW]: SLUGS.WINDOW,
  [SECTIONS.PROPERTY_ITEMS]: SLUGS.PROPERTY_ITEMS,
  ...(isIntercomEnabled() ? { [SECTIONS.INTERCOM]: SLUGS.INTERCOM } : {}),
  [SECTIONS.BATHROOM_STALL]: SLUGS.BATHROOM_STALL,
  [SECTIONS.BATHROOM_CABINET]: SLUGS.BATHROOM_CABINET,
  [SECTIONS.BEDROOM_CLOSET]: SLUGS.BEDROOM_CLOSET,
  [SECTIONS.KITCHEN_CABINET]: SLUGS.KITCHEN_CABINET,

  ...(v2.isEnabled() ? v2.SLUG_BY_SECTION : {}),
});

export const SLUG_TO_SECTION_MAP = Object.freeze({
  [SLUGS.ELECTRICAL]: SECTIONS.ELECTRICAL,
  [SLUGS.FUSEBOX]: SECTIONS.FUSEBOX,
  [SLUGS.LIGHT]: SECTIONS.LIGHT,
  [SLUGS.SWITCH_SOCKET]: SECTIONS.SWITCH_SOCKET,
  [SLUGS.HYDRAULIC]: SECTIONS.HYDRAULIC,
  [SLUGS.REGISTER]: SECTIONS.REGISTER,
  [SLUGS.TOILET]: SECTIONS.TOILET,
  [SLUGS.VALVE]: SECTIONS.VALVE,
  ...(isSinkAndCeilingEnabled() ? { [SLUGS.SINK]: SECTIONS.SINK } : {}),
  [SLUGS.FAUCET]: SECTIONS.FAUCET,
  [SLUGS.SIPHON_TAIL]: SECTIONS.SIPHON_TAIL,
  [SLUGS.SHOWER]: SECTIONS.SHOWER,
  [SLUGS.STRUCTURE]: SECTIONS.STRUCTURE,
  [SLUGS.WALL]: SECTIONS.WALL,
  ...(isSinkAndCeilingEnabled() ? { [SLUGS.CEILING]: SECTIONS.CEILING } : {}),
  [SLUGS.FLOOR]: SECTIONS.FLOOR,
  [SLUGS.DOOR_LOCK]: SECTIONS.DOOR_LOCK,
  [SLUGS.WINDOW]: SECTIONS.WINDOW,
  [SLUGS.PROPERTY_ITEMS]: SECTIONS.PROPERTY_ITEMS,
  ...(isIntercomEnabled() ? { [SLUGS.INTERCOM]: SECTIONS.INTERCOM } : {}),
  [SLUGS.BATHROOM_STALL]: SECTIONS.BATHROOM_STALL,
  [SLUGS.BATHROOM_CABINET]: SECTIONS.BATHROOM_CABINET,
  [SLUGS.BEDROOM_CLOSET]: SECTIONS.BEDROOM_CLOSET,
  [SLUGS.KITCHEN_CABINET]: SECTIONS.KITCHEN_CABINET,

  ...(v2.isEnabled() ? v2.SECTION_BY_SLUG : {}),
});

export const SECTION_PROPS = Object.freeze({
  [SECTIONS.ELECTRICAL]: {
    title: messages.electricalTitle,
    description: messages.electricalDescription,
    backgroundColor: tokens.support.color.surface.default,
    isMainSection: true,
  },
  [SECTIONS.FUSEBOX]: {
    title: messages.fuseboxTitle,
  },
  [SECTIONS.LIGHT]: {
    title: messages.lightTitle,
  },
  [SECTIONS.SWITCH_SOCKET]: {
    title: messages.switchSocketTitle,
  },
  [SECTIONS.HYDRAULIC]: {
    title: messages.hydraulicTitle,
    description: messages.hydraulicDescription,
    backgroundColor: tokens.support.color.surface.default,
    isMainSection: true,
  },
  [SECTIONS.REGISTER]: {
    title: messages.registerTitle,
  },
  [SECTIONS.TOILET]: {
    title: messages.toiletTitle,
  },
  [SECTIONS.VALVE]: {
    title: messages.valveTitle,
  },
  ...(isSinkAndCeilingEnabled()
    ? {
      [SECTIONS.SINK]: {
        title: messages.sinkTitle,
      },
    }
    : {}),
  [SECTIONS.FAUCET]: {
    title: messages.faucetTitle,
  },
  [SECTIONS.SIPHON_TAIL]: {
    title: messages.siphonTailTitle,
  },
  [SECTIONS.SHOWER]: {
    title: messages.showerTitle,
  },
  [SECTIONS.STRUCTURE]: {
    title: messages.structureTitle,
    description: messages.structureDescription,
    backgroundColor: tokens.support.color.surface.default,
    isMainSection: true,
  },
  [SECTIONS.WALL]: {
    title: messages.wallTitle,
  },
  ...(isSinkAndCeilingEnabled()
    ? {
      [SECTIONS.CEILING]: {
        title: messages.ceilingTitle,
      },
    }
    : {}),
  [SECTIONS.FLOOR]: {
    title: messages.floorTitle,
  },
  [SECTIONS.DOOR_LOCK]: {
    title: messages.doorLockTitle,
  },
  [SECTIONS.WINDOW]: {
    title: messages.windowTitle,
  },
  [SECTIONS.PROPERTY_ITEMS]: {
    title: messages.propertyItemsTitle,
    description: messages.propertyItemsDescription,
    backgroundColor: tokens.support.color.surface.default,
    isMainSection: true,
  },
  ...(isIntercomEnabled()
    ? { [SECTIONS.INTERCOM]: { title: messages.intercomTitle } }
    : {}),
  [SECTIONS.BATHROOM_STALL]: {
    title: messages.bathroomStallTitle,
  },
  [SECTIONS.BATHROOM_CABINET]: {
    title: messages.bathroomCabinetTitle,
  },
  [SECTIONS.BEDROOM_CLOSET]: {
    title: messages.bedroomClosetTitle,
  },
  [SECTIONS.KITCHEN_CABINET]: {
    title: messages.kitchenCabinetTitle,
  },

  ...(v2.isEnabled() ? v2.SECTION_PROPS : {}),
});

export const ITEM_PROPS = Object.freeze({
  ELECTRICAL_IS_WORKING: {
    title: messages.electricalIsWorking,
  },
  LIGHT_IS_WORKING: {
    title: messages.lightIsWorking,
  },
  HYDRAULIC_IS_WORKING: {
    title: messages.hydraulicIsWorking,
  },
  REGISTER_IS_WORKING: {
    title: messages.registerIsWorking,
  },
  TOILET_IS_WORKING: {
    title: messages.toiletIsWorking,
  },
  VALVE_IS_WORKING: {
    title: messages.valveIsWorking,
  },
  ...(isSinkAndCeilingEnabled()
    ? {
      SINK_IS_WORKING: { title: messages.sinkIsWorking },
      SINK_CONSERVATION: { title: messages.sinkConservation },
    }
    : {}),
  FAUCET_IS_WORKING: {
    title: messages.faucetIsWorking,
  },
  SHOWER_IS_WORKING: {
    title: messages.showerIsWorking,
  },
  DOOR_LOCK_IS_WORKING: {
    title: messages.doorLockIsWorking,
  },
  WINDOW_IS_WORKING: {
    title: messages.windowIsWorking,
  },
  BATHROOM_STALL_IS_WORKING: {
    title: messages.bathroomStallIsWorking,
  },
  BATHROOM_CABINET_IS_WORKING: {
    title: messages.bathroomCabinetIsWorking,
  },
  BEDROOM_CLOSET_IS_WORKING: {
    title: messages.bedroomClosetIsWorking,
  },
  KITCHEN_CABINET_IS_WORKING: {
    title: messages.kitchenCabinetIsWorking,
  },

  LIGHT_DEFECTIVE_IN: {
    title: messages.lightDefectiveIn,
  },
  REGISTER_DEFECTIVE_IN: {
    title: messages.registerDefectiveIn,
  },
  FAUCET_DEFECTIVE_IN: {
    title: messages.faucetDefectiveIn,
  },
  DOOR_LOCK_DEFECTIVE_IN: {
    title: messages.doorLockDefectiveIn,
  },
  WINDOW_DEFECTIVE_IN: {
    title: messages.windowDefectiveIn,
  },

  LIGHT_COMMENT: {
    title: messages.comment,
    description: messages.commentHint,
  },
  REGISTER_COMMENT: {
    title: messages.comment,
    description: messages.commentHint,
  },
  FAUCET_COMMENT: {
    title: messages.comment,
    description: messages.commentHint,
  },
  DOOR_LOCK_COMMENT: {
    title: messages.comment,
    description: messages.commentHint,
  },
  WINDOW_COMMENT: {
    title: messages.comment,
    description: messages.commentHint,
  },

  FUSEBOX_CONSERVATION: {
    title: messages.fuseboxConservation,
  },
  LIGHT_CONSERVATION: {
    title: messages.lightConservation,
  },
  SWITCH_SOCKET_CONSERVATION: {
    title: messages.switchSocketConservation,
  },
  REGISTER_CONSERVATION: {
    title: messages.registerConservation,
  },
  TOILET_CONSERVATION: {
    title: messages.toiletConservation,
  },
  VALVE_CONSERVATION: {
    title: messages.valveConservation,
  },
  FAUCET_CONSERVATION: {
    title: messages.faucetConservation,
  },
  SIPHON_TAIL_CONSERVATION: {
    title: messages.siphonTailConservation,
  },
  SHOWER_CONSERVATION: {
    title: messages.showerConservation,
  },
  WALL_CONSERVATION: {
    title: messages.wallConservation,
  },
  ...(isSinkAndCeilingEnabled()
    ? { CEILING_CONSERVATION: { title: messages.ceilingConservation } }
    : {}),
  FLOOR_CONSERVATION: {
    title: messages.floorConservation,
  },
  DOOR_LOCK_CONSERVATION: {
    title: messages.doorLockConservation,
  },
  WINDOW_CONSERVATION: {
    title: messages.windowConservation,
  },
  ...(isIntercomEnabled()
    ? {
      INTERCOM_IS_WORKING: { title: messages.intercomIsWorking },
      INTERCOM_CONSERVATION: { title: messages.intercomConservation },
    }
    : {}),
  BATHROOM_STALL_CONSERVATION: {
    title: messages.bathroomStallConservation,
  },
  BATHROOM_CABINET_CONSERVATION: {
    title: messages.bathroomCabinetConservation,
  },
  BEDROOM_CLOSET_CONSERVATION: {
    title: messages.bedroomClosetConservation,
  },
  KITCHEN_CABINET_CONSERVATION: {
    title: messages.kitchenCabinetConservation,
  },

  ...(v2.isEnabled() ? v2.QUESTION_PROPS : {}),
});

export const OPTION_PROPS = Object.freeze({
  [IS_WORKING_TYPES.NO]: {
    title: messages.no,
  },
  [IS_WORKING_TYPES.NO_ANSWER]: {
    title: messages.noAnswer,
  },
  [IS_WORKING_TYPES.YES]: {
    title: messages.yes,
  },
  [DEFECTIVE_IN_TYPES.BEDROOM]: {
    title: messages.bedroom,
  },
  [DEFECTIVE_IN_TYPES.LIVING_ROOM]: {
    title: messages.livingRoom,
  },
  [DEFECTIVE_IN_TYPES.SERVICE_AREA]: {
    title: messages.serviceArea,
  },
  [DEFECTIVE_IN_TYPES.BATHROOM]: {
    title: messages.bathroom,
  },
  [DEFECTIVE_IN_TYPES.KITCHEN]: {
    title: messages.kitchen,
  },
  [DEFECTIVE_IN_TYPES.OTHER]: {
    title: messages.other,
  },
  [CONSERVATION_TYPES.NEEDS_REPAIR]: {
    title: messages.needsRepair,
  },
  [CONSERVATION_TYPES.MANY_SIGNS_OF_USE]: {
    title: messages.manySignsOfUse,
  },
  [CONSERVATION_TYPES.FEW_SIGNS_OF_USE]: {
    title: messages.fewSignsOfUse,
  },
  [CONSERVATION_TYPES.NEW_ITEM]: {
    title: messages.newItem,
  },

  ...(v2.isEnabled() ? v2.ANSWER_PROPS : {}),
});

export const NON_SAVEABLE_SECTIONS = [
  SECTIONS.ELECTRICAL,
  SECTIONS.HYDRAULIC,
  SECTIONS.STRUCTURE,
  SECTIONS.PROPERTY_ITEMS,

  ...(v2.isEnabled() ? v2.NON_SAVEABLE_SECTIONS : []),
];

export const isWorkingId = (id) => `${id}_IS_WORKING`;
export const defectiveInId = (id) => `${id}_DEFECTIVE_IN`;
export const commentId = (id) => `${id}_COMMENT`;
export const conservationId = (id) => `${id}_CONSERVATION`;
